import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static targets = ["categorySelect"]

  connect() {
    this.initCategoryChoices()
  }

  disconnect() {
    if (this.categoryChoices) {
      this.categoryChoices.destroy()
    }
  }

  initCategoryChoices() {
    if (this.hasCategorySelectTarget) {
      this.categoryChoices = new Choices(this.categorySelectTarget, {
        searchEnabled: true,
        itemSelectText: '',
        shouldSort: false
      })
    }
  }

  submitForm(event) {
    // Submit the form when category is changed
    event.target.form.requestSubmit()
  }
}
